export class ServicoTomadoListaRequest {
  searchText?: string;
  listIdStatusFiscalNFSeEntrada?: number[];
  dataEmissaoInicio?: string;
  dataEmissaoFim?: string;
}
